import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"
import _imports_0 from '@/engineproject/default/common/assets/images/android-chrome-192x192.png'


const _hoisted_1 = { class: "col1 mainMenu" }
const _hoisted_2 = { class: "inline floatLeft" }
const _hoisted_3 = { class: "homeNameArea mainMenuAbout" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "logoInMainMenu",
  src: _imports_0
}, null, -1)
const _hoisted_5 = { class: "appVersion" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "inline" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["onClick", "title"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "pi pi-refresh" }, null, -1)
const _hoisted_11 = ["title"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "pi pi-user-plus" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "pi pi-home" }, null, -1)
const _hoisted_14 = { "data-cy": "cyAdsListingMenu" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "pi pi-plus" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "pi pi-bell" }, null, -1)
const _hoisted_17 = ["title"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, " € ", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "floatingCounter",
  "data-cy": "cyMainMenuNotifNotViewedCounter"
}
const _hoisted_21 = { class: "profilImgContainer imgClassContainer" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", null, "▼", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppColoredName = _resolveComponent("AppColoredName")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SwitchLanguage = _resolveComponent("SwitchLanguage")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_FormatUserPicture = _resolveComponent("FormatUserPicture")!
  const _component_SiteNavTemplate = _resolveComponent("SiteNavTemplate")!

  return (_openBlock(), _createBlock(_component_SiteNavTemplate, null, {
    content: _withCtx(({showNav, newAppVersion, pPseudo, menuProfilItems, adminMenuProfilItems, pUserPictureUrl, 
      pUserNotifNotViewed, pUserInvitWithGainNotViewed, isAdmin,
      installNewAppVersion}) => [
      (showNav() == true)
        ? (_openBlock(), _createElementBlock("header", {
            key: 0,
            class: _normalizeClass({OnSmallScreenOnly: $props.OnSmallScreenOnly, OnLargeScreenOnly: $props.OnLargeScreenOnly})
          }, [
            _createElementVNode("section", null, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("ul", _hoisted_2, [
                  _createElementVNode("li", _hoisted_3, [
                    _createVNode(_component_router_link, { to: "/home" }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", null, [
                          _createVNode(_component_AppColoredName),
                          _hoisted_4,
                          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.vueAppVersion), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_SwitchLanguage)
                    ])
                  ])
                ]),
                _createElementVNode("ul", _hoisted_7, [
                  (newAppVersion!='')
                    ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                        _createElementVNode("div", {
                          class: "profilMenu newAppVersionMenu",
                          onClick: ($event: any) => (installNewAppVersion()),
                          title: $setup.t('newAppVersionTitle'),
                          "data-cy": "cyMainMenuNewVersion"
                        }, [
                          _hoisted_10,
                          _createElementVNode("div", null, _toDisplayString($setup.t('newAppVersionMenu')), 1)
                        ], 8, _hoisted_9)
                      ]))
                    : _createCommentVNode("", true),
                  isAdmin
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 1,
                        class: _normalizeClass(["mainMenuAdmin", $setup.isSelectedMenu('mainMenuAdmin')])
                      }, [
                        _createElementVNode("div", {
                          class: "profilMenu adminDisplayColor",
                          "data-cy": "cyMainMenuAdmin",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.adminToggle && $setup.adminToggle(...args))),
                          title: $setup.t('adminMode')
                        }, [
                          _hoisted_12,
                          _createElementVNode("div", null, _toDisplayString($setup.t('adminMode')), 1)
                        ], 8, _hoisted_11),
                        _createVNode(_component_Menu, {
                          ref: "adminMenu",
                          model: adminMenuProfilItems,
                          popup: true
                        }, null, 8, ["model"])
                      ], 2))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", {
                    class: _normalizeClass(["mainMenuHome", $setup.isSelectedMenu('mainMenuHome')])
                  }, [
                    _createVNode(_component_router_link, {
                      title: $setup.t('adsListingTitle'),
                      to: '/' + _ctx.currentFilterAttributes,
                      class: "profilMenu",
                      "data-cy": "cyMainMenuHome"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13,
                        _createElementVNode("div", _hoisted_14, _toDisplayString($setup.t("adsListing")), 1)
                      ]),
                      _: 1
                    }, 8, ["title", "to"])
                  ], 2),
                  _createElementVNode("li", {
                    class: _normalizeClass(["mainMenuAdd", $setup.isSelectedMenu('mainMenuAdd')])
                  }, [
                    _createVNode(_component_router_link, {
                      title: $setup.t('addItemTitle'),
                      to: "/add",
                      class: "profilMenu",
                      "data-cy": "cyMainMenuAdd"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_15,
                        _createElementVNode("div", null, _toDisplayString($setup.t('addItem')), 1)
                      ]),
                      _: 1
                    }, 8, ["title"])
                  ], 2),
                  _createElementVNode("li", {
                    class: _normalizeClass(["mainMenuNotifications", $setup.isSelectedMenu('mainMenuNotifications')])
                  }, [
                    _createVNode(_component_router_link, {
                      title: $setup.t('myNotificationsTitle'),
                      to: "/notifications",
                      class: "profilMenu",
                      "data-cy": "cyMainMenuNotif"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16,
                        _createElementVNode("div", null, _toDisplayString($setup.t('myNotifications')), 1),
                        (pUserInvitWithGainNotViewed>0)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "floatingCounter floatingCounterLeft",
                              title: $setup.t('invitationWithGainReceived', {invitationsNumber: pUserInvitWithGainNotViewed}),
                              "data-cy": "cyMainInvitWithGainNotifNotViewedCounter"
                            }, _hoisted_19, 8, _hoisted_17))
                          : _createCommentVNode("", true),
                        (pUserNotifNotViewed>0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createElementVNode("div", null, _toDisplayString(pUserNotifNotViewed), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["title"])
                  ], 2),
                  _createElementVNode("li", {
                    class: _normalizeClass(["mainMenuSettings", $setup.isSelectedMenu('mainMenuSettings')])
                  }, [
                    _createElementVNode("div", {
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.toggle && $setup.toggle(...args))),
                      class: "profilMenu",
                      "data-cy": "cyProfileMenu"
                    }, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_FormatUserPicture, { pUserPictureUrl: pUserPictureUrl }, null, 8, ["pUserPictureUrl"])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", null, _toDisplayString(pPseudo), 1),
                        _hoisted_22
                      ])
                    ]),
                    _createVNode(_component_Menu, {
                      ref: "menu",
                      model: menuProfilItems,
                      popup: true
                    }, null, 8, ["model"])
                  ], 2)
                ])
              ])
            ])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}